module.exports = __webpack_public_path__ + "static/media/logo-color.a8b4c2b8.png";